import React from 'react';
import ContentLoader from 'react-content-loader';
import { PLACEHOLDER } from '../../constants';

export default function Input({ ...props }) {
  const svgProps = {
    height: PLACEHOLDER.INPUT.height,
    width: PLACEHOLDER.INPUT.width,
    ...props
  };

  return (
    <>
      <ContentLoader {...svgProps}>
        <rect x="0" y={PLACEHOLDER.INPUT.labelHeight} {...svgProps} />
      </ContentLoader>
    </>
  );
}

Input.defaultProps = {};

Input.propTypes = {};
